import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';

export const chartModeToDuration = (mode: ChartViewMode): Duration => ({
  days: mode === ChartViewMode.Daily ? 1 : 0,
  weeks: mode === ChartViewMode.Weekly ? 1 : 0,
  months: mode === ChartViewMode.Monthly ? 1 : 0,
});
